export default {
  error_messages: {
    orders_disabled: 'Hier bestellen momenteel niet mogelijk',
  },
};
